import { render, staticRenderFns } from "./CouponPageQuick.vue?vue&type=template&id=402b75d0&scoped=true&"
import script from "./CouponPageQuick.vue?vue&type=script&lang=ts&"
export * from "./CouponPageQuick.vue?vue&type=script&lang=ts&"
import style0 from "./CouponPageQuick.vue?vue&type=style&index=0&id=402b75d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b75d0",
  null
  
)

export default component.exports